import React from "react";
import { useDocument } from "../loan_tool";

/**
 * Email button for a Forms disclosure page (Borrower Auth, Credit Auth, the
 * letters, etc.). Opens the LO's own Outlook/Gmail (mailto) pre-filled with the
 * borrower(s) and a subject — NO body, so the LO's own standard signature (which
 * carries the NMLS / SAFE Act disclaimer + license numbers) is not suppressed.
 * The LO attaches the PDF they saved (the page's Print/Save-as-PDF already names
 * the file via the route's page-title override) and sends. Client-side only.
 */
export default function FormEmailButton({ docName }) {
  const [document, , { documentAccountProfile }] = useDocument();
  const borrowers = (document.applicant && document.applicant.borrowers) || [];
  const last = (borrowers[0] && borrowers[0].last_name) || "Borrower";

  function emailForm() {
    const to = borrowers
      .map(b => b && b.email)
      .filter(Boolean)
      .join(",");
    const lo = [
      documentAccountProfile && documentAccountProfile.first_name,
      documentAccountProfile && documentAccountProfile.last_name
    ]
      .filter(Boolean)
      .join(" ");
    const subject = `${last} — ${docName}${lo ? " from " + lo : ""}`;
    window.location.href =
      "mailto:" +
      encodeURIComponent(to) +
      "?subject=" +
      encodeURIComponent(subject);
  }

  return (
    <button
      className="button"
      onClick={emailForm}
      title="Open your email with the borrower and subject pre-filled; attach the PDF you saved, then send"
    >
      Email…
    </button>
  );
}
